import { all, takeLatest, takeEvery } from 'redux-saga/effects'
import ClientAPI from '../services/api/clientsAPi'
import ProductAPI from '../services/api/productsAPI'
import AuditAPI from '../services/api/auditAPI'
import AccountDataAPI from '../services/api/accountDataAPI'
import TicketsAPI from '../services/api/ticketsApi'

/* ------------- Types ------------- */
import { AuthTypes } from '../store/authRedux'
import { ClientTypes } from '../store/clientRedux'
import { ProductTypes } from '../store/productRedux'
import { LayoutTypes } from '../store/layoutRedux'
import { TicketTypes } from '../store/ticketRedux'

/* ------------- Sagas ------------- */
import {
    loginUser,
    restoreUserSession,
    handleLoginCallback,
    logoutUser,
    finalizeLogout
} from './authSagas'
import {
    searchClients,
    getDiyProductsByAccount,
    createSearchLog,
    getAccountHistoryById,
    getSecurityInfoById,
    getClientById,
    searchReturns,
    searchAssociatedReturn,
    getParty
} from './clientSagas'
import {
    getDiyReturn,
    getExpertReview,
    getAuditProtection,
    getPresale,
    getSelectedOte,
    getActivationCodes,
    getFiledReturn
} from './productSagas'
import {
    setAccountDataLanguage
} from './layoutSagas'
import {
    queryTickets,
    getTicket,
    getEligibleAddonProducts
} from './ticketSagas'

//import { createSearchLog } from './auditSagas'

/* ------------- API ------------- */
// The API we use is only used from Sagas, so we create it here and pass along to the sagas which need it.
const clientApi = ClientAPI.create()
const productApi = ProductAPI.create()
const auditApi = AuditAPI.create()
const ticketsApi = TicketsAPI.create()

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
    yield all([
        //auth
        takeLatest(AuthTypes.REQUEST_LOGIN, loginUser),
        takeLatest(AuthTypes.PROCESS_LOGIN_CALLBACK, handleLoginCallback),
        takeLatest(AuthTypes.RESTORE_USER_SESSION, restoreUserSession),
        takeLatest(LayoutTypes.SET_LANGUAGE, setAccountDataLanguage),

        //ticket
        takeEvery(TicketTypes.QUERY_TICKETS, queryTickets, ticketsApi),
        takeLatest(TicketTypes.GET_TICKET, getTicket, ticketsApi),
        takeLatest(TicketTypes.GET_ELIGIBLE_ADDON_PRODUCTS, getEligibleAddonProducts, ticketsApi),

        //client
        takeLatest(ClientTypes.SEARCH_CLIENTS, searchClients, clientApi),
        takeLatest(ClientTypes.GET_CLIENT, getClientById, clientApi),
        takeLatest(ClientTypes.GET_DIY_RETURNS, getDiyProductsByAccount, productApi),
        takeLatest(ClientTypes.GET_ACCOUNT_HISTORY, getAccountHistoryById, clientApi),
        takeLatest(ClientTypes.CREATE_SEARCH_LOG, createSearchLog, auditApi),
        takeLatest(ClientTypes.GET_SECURITY_INFO, getSecurityInfoById, clientApi),
        takeLatest(ClientTypes.SEARCH_RETURNS, searchReturns, clientApi),
        takeLatest(ClientTypes.SEARCH_ASSOCIATED_RETURN, searchAssociatedReturn, clientApi),
        takeLatest(ClientTypes.GET_PARTY, getParty, clientApi),

        //product
        takeLatest(ProductTypes.GET_SELECTED_DIY_RETURN, getDiyReturn, productApi),
        takeLatest(ProductTypes.GET_EXPERT_REVIEW, getExpertReview, productApi),
        takeLatest(ProductTypes.GET_AUDIT_PROTECTION, getAuditProtection, productApi),
        takeLatest(ProductTypes.GET_SELECTED_PRESALE, getPresale, productApi),
        takeLatest(ProductTypes.GET_SELECTED_OTE, getSelectedOte, productApi),
        takeLatest(ProductTypes.GET_ACTIVATION_CODES, getActivationCodes, productApi),
        takeLatest(ProductTypes.GET_FILED_RETURN, getFiledReturn, productApi),

        //logout
        takeLatest(AuthTypes.LOGOUT_USER, logoutUser),
        takeLatest(AuthTypes.FINALIZE_LOGOUT, finalizeLogout)
    ])
}